<template>
  <div v-if="isMembersLoaded">
    <!-- {{localAccount}} -->
    <!-- {{getMembers}}
    {{localMembers}} -->

    <div class="columns">
      <div class="column is-half">
        
        <!-- {{profile.members}} -->

        <div v-for="member in localMembers" v-bind:key="member.id">
          <a  @click="selectmember(member)" >
            <!-- <ListPanelItem :contact='contact' style="margin-bottom: 1em;"/> -->
            {{member.username}} | {{member.email}}
          </a>
        </div>

        <b-button class="button is-primary" @click="newMember">
          <strong>NEW</strong>
        </b-button>

        <!-- <b-button class="button is-primary" @click="onSaveAccount">
          <strong>SAVE</strong>
        </b-button> -->

      </div>


      <div class="column is-half">
        <!-- {{selectedmember}} -->

        <section v-if="!selectedmember">
          <div><b>No member selected</b></div>
        </section>



        <section v-if="selectedmember">

          <ValidationObserver v-slot="{ passes }">
            
            <form @submit.prevent="passes(onSaveOrUpdateMember)" class="from">

              <div class="field">
                <b-switch v-model="selectedmember.active">
                  {{selectedmember.active ? "User active" : "User deactivated"}}
                </b-switch>
              </div>
              

              <b-field>
                <b-select v-model="selectedmember.role" expanded>  
                  <option value="">Select Role</option>
                  <option v-for="value in roleSelectorValues"
                          :value="value.name" v-bind:key="value.id">
                    {{ value.name }} 
                  </option>
                </b-select>
              </b-field>

              <ValidationProvider name="email" rules="required|email" v-slot="{ errors, classes }">
                <!-- {{errors}} -->

                <b-field
                  :type="{'is-danger': errors.length > 0}"
                  :message="errors[0]" label="Email" label-position="on-border">
                  <b-input type="email" placeholder="email"  
                      v-model="selectedmember.email"
                      maxlength="30">
                  </b-input>
                </b-field>

              </ValidationProvider>

              <b-field>
                  <b-input v-model="selectedmember.username" placeholder="username"></b-input>
              </b-field>

              <b-field>
                  <b-input v-model="selectedmember.initialpwd" placeholder="initial password" type="password"></b-input>
              </b-field>

              <div class="buttons">
                <b-tooltip type="is-dark" label="Deactive User to reset password">
                    <b-icon
                      pack="fas"
                      icon="question-circle"
                      size="is-small"
                      type="is-gold">
                  </b-icon>
                </b-tooltip>

                <b-button :disabled="selectedmember.active" class="button is-primary" @click="resetPassword">
                  <strong>Reset Password</strong>
                </b-button>

              
                <b-button :disabled="selectedmember.active || !selectedmember.email || !selectedmember.initialpwd" class="button is-primary" @click="passes(sendEmailInvitation)">
                  <strong>Send Email</strong>
                </b-button>
              </div>

              <!-- <span v-if="selectedmember.active">Deactive User to reset password</span> -->

              <hr>

              <div><b>Personal data</b></div>
              <br>

              <b-field>
                  <b-input v-model="selectedmember.firstname" placeholder="first name"></b-input>
              </b-field>

              <b-field>
                  <b-input v-model="selectedmember.name" placeholder="name"></b-input>
              </b-field>

              <b-field>
                  <b-input v-model="selectedmember.phone" placeholder="phone number"></b-input>
              </b-field>

              
              <button class="button is-primary">
                <strong>Save</strong>
              </button>

              
          


            </form>
          </ValidationObserver>

          <!-- </section>

          <section> -->
<!-- 
          <div class="buttons my-center-horizontal">
            <a class="button is-primary" @click="saveProfile">
              <strong>SAVE</strong>
            </a>
          </div> -->

          

        </section>
        
      </div>

    </div>

        

    
  
  </div>
</template>

<script>

  import { ValidationObserver, ValidationProvider } from "vee-validate";
  import { mapGetters, mapActions } from 'vuex';
  import { MemberStruct } from '@/utils/structs';

  //..Validation / see> https://baianat.github.io/vee-validate/examples/multiple-forms.html#same-page-forms
  
  function createRandomString () {
    return Math.random().toString(36).slice(-8);
  }

  export default {
    name: 'MemberPanel',
    components: {
      ValidationProvider,
      ValidationObserver
      },
      data() {
        return  {
          
          selectedmember: null,
          isnewmember: false,
          roleSelectorValues: [],
          localMembers: null,
        }
      },
      created() {
        this.roleSelectorValues = [
          {id: 1, name: "ADMIN"},
          {id: 2, name: "USER"},
          {id: 3, name: "INTERN"},
        ]
        this.localMembers = JSON.parse(JSON.stringify(this.getMembers))
      },
      computed: {
        ...mapGetters(['getMembers', 'isMembersLoaded']),
        // ...mapState(['user', 'account'])
      },
      methods: {
        ...mapActions(['addNewMember', 'updateMember', 'deleteMember']),
        // addMember () {
        //   if (this.isnewmember) {
        //     // this.saveMember(this.selectedmember)
        //     // this.profile.members.push(this.selectedmember)
        //     // user.profile.account.members.push(this.selectedmember)
        //     this.localMembers.members.push(this.selectedmember)
        //   } else {
        //     this.updateMember(this.selectedmember)
        //   }
        //   this.isnewmember = false
        //   console.log(this.profile)
        //   // window.alert(JSON.stringify(this.profile))
        // },

        onSaveOrUpdateMember () {
          if (this.selectedmember.id === "") {
            this.addNewMember(this.selectedmember)
          } else {
            this.updateMember(this.selectedmember)
          }
        },
        newMember () {
          // var randomstring = Math.random().toString(36).slice(-8);
          this.selectedmember = MemberStruct
          // this.selectedmember.username = "NewUser"
          // this.selectedmember.id = 'mock_'+new Date().getTime().toString()
          this.selectedmember.initialpwd= createRandomString()
          this.isnewmember = true
          console.log(this.profile)
          // window.alert(JSON.stringify(this.profile))
        },
        resetPassword () {
          this.selectedmember.initialpwd = createRandomString()
        },
        sendEmailInvitation () {
          console.log("TODO> SEND EMAIL INVITATION")
          this.$buefy.notification.open('Sending Email!')
        },
        // isEmailValid () {
        //   return (this.selectedmember.email == "")? "" : (this.reg.test(this.selectedmember.email)) ? 'has-success' : 'has-error';
        // },
        selectmember (member) {
          this.selectedmember = member
        },
        // onSaveMember () {
        //   // console.log(this.localMembers)
        //   this.saveMember(this.selectedmember)
        // }
      },
      
    watch: {
      getMembers (newVal) {
        this.localMembers = JSON.parse(JSON.stringify(newVal))
        console.log("getMembers updated ... watch")
      }
    }
      
    // computed: {
    //   ...mapGetters(['getProfile'])
    // }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .myheaderbar {
      height: 3em;
      line-height: 3em;
      background: lightgray;
      text-align: left;
      padding-left: 1em;
    }
    .mybuttons {
      justify-content: center;
    }
    .my-center-horizontal {
      display: block;
    }
</style>